<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuth } from '@/composables/useAuth'

defineProps<{
  message: string
}>()

const { t } = useI18n()
const { currentOrganisation } = useAuth()
</script>

<template>
  <div
    class="mb-4 rounded-xl bg-amber-500/10 border border-amber-500/30 px-5 py-3 text-sm text-amber-300"
    role="alert"
    data-testid="payout-not-ready-notice"
  >
    <p>{{ message }}</p>
    <RouterLink
      v-if="currentOrganisation"
      :to="{ name: 'organizer.organisations.settings.payments', params: { orgSlug: currentOrganisation.slug } }"
      class="mt-2 inline-block font-semibold text-amber-200 hover:text-amber-100 transition-colors"
    >
      {{ t('payouts.publish_blocked_link') }}
    </RouterLink>
  </div>
</template>
